<template>
  <div class="robins-egg-bkgr pa-5">
    <div class="stockli-admin-container">
      <div class="h2">Edit Participant &amp; Skis</div>
      
      <div v-if="participant" class="participant-details-box">
        <div class="h2">{{ participant.Full_Name }}</div>
        <v-row dense>
          <v-col cols="12" class="large-text">
            <span class="sm-text uppercase">Indicator Setting: </span>
            <span class="xxl-text bold-text">{{ participant.Indicator_Setting }}</span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6" class="large-text">
            <span class="sm-text uppercase">Boot Make: </span>
            <span class="md-text bold-text">{{ participant.Boot_Make }}</span>
          </v-col>

          <v-col cols="6" class="large-text">
            <span class="sm-text uppercase">Boot Length: </span>
            <span class="md-text bold-text">{{ participant.Sole }}</span>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6" class="large-text">
            <span class="sm-text uppercase">Mobile: </span>
            <span class="md-text bold-text">{{ participant.Mobile | phone }}</span>
          </v-col>
        </v-row>
      </div> 

      <v-row>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :items="attendance"
            :headers="attendanceHeaders"
            hide-default-footer
            disable-sort
            mobile-breakpoint="300"
            no-data-text="This participant has not attended a demo yet. You can claim them below."
            :loading="loadingAttendance"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn class="highlight-btn" @click="PromptClaimParticipant()">Claim this participant</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :items="skis"
            :headers="skiHeaders"
            hide-default-footer
            disable-sort
            mobile-breakpoint="300"
            no-data-text="This participant has not tested any skis yet"
            :loading="loadingSkis"
          >
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.Returned="{ item }">
              <v-simple-checkbox :value="item.Returned" @input="ToggleReturned(item)" />
            </template>
            <!-- eslint-disable-next-line vue/valid-v-slot -->
            <template v-slot:item.Delete="{ item }">
              <v-btn @click="PromptDeleteSki(item)" icon color="primary">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-btn @click="addingDialog = true" class="highlight-btn">Add Tested Ski</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>
      <div class="mt-5">
        <router-link to="/participants" class="btn">Back to all participants</router-link>
      </div>
  
      <v-dialog v-model="addingDialog" max-width="500px">
        <v-form ref="form" @submit.prevent="PerformAddSki">
          <v-card>
            <v-card-title>
              <span class="h3">Add Tested Ski</span>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select label="Ski Name" v-model="addingSki.Name" item-text="Name" item-value="Name" :items="skiTypes" :rules="[ruleRequired]" />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field v-model="addingSki.Size" label="Size (cm)" :rules="[ruleRequired]" />
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="addingDialog = false" :disabled="addProcessing" text>Cancel</v-btn>
              <v-btn type="submit" :disabled="addProcessing" :loading="addProcessing" text>Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog v-model="deletingDialog" max-width="500px">
        <v-card>
          <v-card-title class="text-h5">Are you sure you want to delete this ski?</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deletingDialog = false" :disabled="deleteProcessing">Cancel</v-btn>
            <v-btn text @click="PerformDeleteSki" :disabled="deleteProcessing" :loading="deleteProcessing">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="claimingDialog" max-width="500px">
        <v-card v-if="!location">
          <v-card-title class="h3">No location selected!</v-card-title>
          <v-card-text>
            <p>
              You must first <router-link to="/location">set your location</router-link> to claim a participant.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="claimingDialog = false">Cancel</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
        <v-card v-else>
          <v-card-title class="h4">Are you sure you want to claim this participant?</v-card-title>
          <v-card-text>
            <v-alert v-if="alreadyClaimed" type="warning">
              This participant has already been claimed today.
              A participant should never be claimed twice in one day.
              This should only be done if the previous claim today was a mistake.
            </v-alert>
            <p
              v-else-if="attendance && attendance.length > 0"
            >This participant has already been claimed, but can be claimed again if they are attending another demo during the same season.</p>
            <p>New location for today: "{{ location.Name }}"</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="claimingDialog = false" :disabled="claimProcessing">Cancel</v-btn>
            <v-btn text @click="PerformClaimParticipant" :disabled="claimProcessing" :loading="claimProcessing">OK</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import { Utilities } from "@/services/utilities";

export default {
  name: "EditParticipant",
  components: {
  },
  data: () => ({
    participant: undefined,
    attendance: [],
    skis: [],
    skiTypes: [],

    skiHeaders: [
      { text: "Tested Ski", value: "Name" },
      { text: "Size", value: "Size" },
      { text: "Returned", value: "Returned" },
      { text: "", value: "Delete", align: "end" },
    ],
    loadingSkis: false,
    attendanceHeaders: [
      { text: "Attendance", value: "Location.Name" },
      { text: "Date", value: "Date" },
      { text: "Sales Rep", value: "Sales_Rep.Name" },
    ],
    loadingAttendance: false,

    claimingDialog: false,
    claimProcessing: false,

    addingSki: {
      Name: undefined,
      Size: undefined,
    },
    addingDialog: false,
    addProcessing: false,

    deletingSki: undefined,
    deletingDialog: false,
    deleteProcessing: false,

    ruleRequired: v => !!v || "This field is required",
  }),
  computed: {
    location() {
      return this.$store.state.location;
    },
    alreadyClaimed() {
      if (!this.attendance) return false;
      const today = Utilities.GetZohoDate(new Date());
      return (this.attendance.some(item => item["Date"] === today));
    }
  },
  mounted() {
    this.RefreshSkiTypes();
    this.RefreshParticipant();
    this.RefreshAttendance();
    this.RefreshSkis();
  },
  methods: {
    async RefreshSkiTypes() {
      this.skiTypes = await API.GetSkiTypes();
    },

    async RefreshParticipant() {
      this.participant = await API.GetParticipant(this.$route.params.id);
    },

    async RefreshAttendance() {
      try {
        this.loadingAttendance = true;
        this.attendance = await API.GetParticipantAttendance(this.$route.params.id);
      } finally {
        this.loadingAttendance = false;
      }
    },

    async RefreshSkis() {
      try {
        this.loadingSkis = true;
        this.skis = await API.GetParticipantSkis(this.$route.params.id);
      } finally {
        this.loadingSkis = false;
      }
    },

    PromptClaimParticipant() {
      this.claimingDialog = true;
    },
    async PerformClaimParticipant() {
      try {
        this.claimProcessing = true;
        await API.CreateParticipantAttendance(this.participant.id, this.location.id, this.location.Name);
        await this.RefreshAttendance();
        this.claimingDialog = false;
      } finally {
        this.claimProcessing = false;
      }
    },

    async PerformAddSki() {
      if (!this.$refs.form.validate()) return;

      try {
        this.addProcessing = true;
        await API.CreateParticipantSki(this.participant.id, this.addingSki);
        await this.RefreshSkis();
        this.addingDialog = false;
      } finally {
        this.addProcessing = false;
      }
    },

    async ToggleReturned(ski) {
      ski.Returned = !ski.Returned;
      await API.UpdateParticipantSki(ski.id, { Returned: ski.Returned });
    },

    PromptDeleteSki(ski) {
      this.deletingSki = ski;
      this.deletingDialog = true;
    },

    async PerformDeleteSki() {
      try {
        this.deleteProcessing = true;
        await API.DeleteParticipantSki(this.deletingSki.id);
        await this.RefreshSkis();
        this.deletingDialog = false;
      } finally {
        this.deleteProcessing = false;
      }
    }
  },
}
</script>
<style scoped lang="scss">
</style>
